export default (option, wrapperElement) => {
    let element = document.getElementById(wrapperElement);
    element.classList.remove(option.remove);
    element.classList.add(option.add);
}